var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._l((_setup.handleTextMessageShowContext(_setup.props.data)),function(item,index){return _c('span',{key:index},[(item.name === 'text')?_c('span',{staticClass:"text-box"},[_vm._v(_vm._s(item.text))]):(item.name === 'img')?_c('img',{staticClass:"text-img",attrs:{"src":item.src}}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }